import { productConfig } from './product.config.js'

const profileEditRoutes = [
  {
    path: 'personal-specs',
    name: 'EditPersonalSpecs',
    component: () => import('./views/profile/edit/EditPersonalSpecs.vue'),
  },
  {
    path: 'records',
    name: 'EditRecords',
    component: () => import('./views/profile/edit/EditRecords.vue'),
  },
  {
    path: 'training-frequency',
    name: 'EditTrainingFrequency',
    component: () => import('./views/profile/edit/EditTrainingFrequency.vue'),
  },
  {
    path: 'transformation',
    name: 'EditTransformation',
    component: () => import('./views/profile/edit/EditTransformation.vue'),
  },
  {
    path: 'app-statistics',
    name: 'EditAppStatistics',
    component: () => import('./views/profile/edit/EditAppStatistics.vue'),
  },
]

const myRoutes = [
  {
    path: 'profile/onwards-finish',
    name: 'OnwardsFinish',
    component: () => import('./views/onwards/OnwardsFinish.vue'),
    meta: { layout: 'EmptyLayout' },
  },
  {
    path: 'trainings-list',
    name: 'TrainingsList',
    component: () => import('./views/trainings/TrainingsList.vue'),
    meta: { navigationTab: 'trainings-list' },
  },
  {
    path: 'trainings-catalog',
    name: 'TrainingsCatalog',
    redirect: { name: 'CreateProgram' },
  },
  {
    path: 'create-program',
    name: 'CreateProgram',
    component: () => import('./views/trainings/CreateProgram.vue'),
    meta: { navigationTab: 'trainings-list' },
  },
  {
    path: 'trainings',
    name: 'Trainings',
    redirect: { name: 'Bodybuilding' },
    children: [
      {
        path: 'bodybuilding',
        name: 'Bodybuilding',
        component: () => import('./views/trainings/Bodybuilding/BodybuildingMain.vue'),
      },
      {
        path: 'bodybuilding/training-program',
        name: 'BodybuildingChoiceProgram',
        component: () => import('./views/trainings/Bodybuilding/BodybuildingChoiceProgram.vue'),
      },
      {
        path: 'bodybuilding/specialization',
        name: 'BodybuildingSpecialization',
        component: () => import('./views/trainings/Bodybuilding/BodybuildingSpecialization.vue'),
      },
      {
        path: 'bodybuilding/schedule-start',
        name: 'BodybuildingScheduleStart',
        component: () => import('./views/trainings/Common/ProgramScheduleStart.vue'),
      },
      {
        path: 'bodybuilding/created-program/:id',
        name: 'BodybuildingProgramCreated',
        component: () => import('./views/trainings/Bodybuilding/BodybuildingProgramCreated.vue'),
      },
      {
        path: 'bodybuilding/:id',
        name: 'BodybuildingTrainingCycle',
        component: () => import('./views/trainings/Bodybuilding/BodybuildingTrainingCycle.vue'),
      },
      {
        path: 'bodybuilding/:id/:training',
        name: 'BodybuildingTrainingDay',
        component: () => import('./views/trainings/Bodybuilding/BodybuildingTrainingDay.vue'),
      },
      {
        path: 'bodybuilding/:id/:training/:ex',
        name: 'BodybuildingTrainingExercise',
        component: () => import('./views/trainings/Bodybuilding/BodybuildingTrainingExercise.vue'),
      },
      {
        path: 'bodybuilding/:id/:training/finish',
        name: 'BodybuildingTrainingFinishPage',
        component: () => import('./views/trainings/Bodybuilding/BodybuildingTrainingFinishPage.vue'),
      },
      {
        path: 'powerlifting',
        name: 'Powerlifting',
        component: () => import('./views/trainings/Powerlifting/PowerliftingMain.vue'),
      },
      {
        path: 'powerlifting/opm',
        name: 'PowerliftingOPM',
        component: () => import('./views/trainings/Powerlifting/PowerliftingOPM.vue'),
      },
      {
        path: 'powerlifting/schedule-start',
        name: 'PowerliftingScheduleStart',
        component: () => import('./views/trainings/Common/ProgramScheduleStart.vue'),
      },
      {
        path: 'powerlifting/created-program/:id',
        name: 'PowerliftingProgramCreated',
        component: () => import('./views/trainings/Powerlifting/PowerliftingProgramCreated.vue'),
      },
      {
        path: 'powerlifting/:id',
        name: 'PowerliftingTrainingCycle',
        component: () => import('./views/trainings/Powerlifting/PowerliftingTrainingCycle.vue'),
      },
      {
        path: 'powerlifting/:id/:training',
        name: 'PowerliftingTrainingDay',
        component: () => import('./views/trainings/Powerlifting/PowerliftingTrainingDay.vue'),
      },
      {
        path: 'powerlifting/:id/:training/:ex',
        name: 'PowerliftingTrainingExercise',
        component: () => import('./views/trainings/Powerlifting/PowerliftingTrainingExercise.vue'),
      },
      {
        path: 'powerlifting/:id/:training/finish',
        name: 'PowerliftingTrainingFinishPage',
        component: () => import('./views/trainings/Powerlifting/PowerliftingTrainingFinishPage.vue'),
      },
      {
        path: 'random-training',
        name: 'RandomTraining',
        component: () => import('./views/trainings/RandomTraining/RandomTrainingMain.vue'),
      },
      {
        path: 'random-training/created-program',
        name: 'RandomTrainingFinalProgram',
        component: () => import('./views/trainings/RandomTraining/RandomTrainingFinalProgram.vue'),
      },
    ],
  },
]

const product = {
  ...productConfig,
  chatRequiresActiveSubscription: true,
  getIncompleteProfileLabel(profile) {
    return profile?.first_name?.trim()
      ? 'Пройди диагностику'
      : 'Заполни профиль'
  },
  components: {
    home: () => import('./views/home/Home.vue'),
    profile: () => import('./views/profile/UserProfile.vue'),
    profileCard: () => import('./views/profile/UserProfile.vue'),
    faq: () => import('@/views/system/Page404.vue'),
    onboarding: () => import('./views/onboarding/Onboarding.vue'),
    onwards: () => import('./views/onwards/Onwards.vue'),
    editProfile: () => import('./views/profile/edit/EditProfile.vue'),
    editLookingFor: () => import('./views/profile/edit/EditLookingFor.vue'),
    editNiches: () => import('./views/profile/edit/EditNiches.vue'),
    marketplaceBroadcasts: () => import('./views/study/broadcasts/MarketplaceBroadcasts.vue'),
    marketplaceBroadcastLanding: () => import('./views/study/broadcasts/MarketplaceBroadcastLanding.vue'),
    subscriptionOffer: () => import('@/views/policy/bodybase/SubscriptionOffer.vue'),
    privacyPolicy: () => import('@/views/policy/bodybase/PrivacyPolicy.vue'),
    informationAdvertisingPolicy: () => import('@/views/policy/bodybase/InformationAdvertisingPolicy.vue'),
    userAgreement: () => import('@/views/policy/bodybase/UserAgreement.vue'),
    personalDataProcessing: () => import('@/views/policy/bodybase/PersonalDataProcessing.vue'),
  },
  assets: {
    favicon: new URL('./assets/images/icons/favicon.svg', import.meta.url).href,
    logo128x58: new URL('./assets/images/logos/logo128x58.png', import.meta.url).href,
    logo186x84: new URL('./assets/images/logos/logo186x84.png', import.meta.url).href,
    poweredBy: new URL('./assets/images/logos/poweredBy.png', import.meta.url).href,
    logoLeadPay128x58: new URL('./assets/images/logos/logo128x58_WithLeadPay.png', import.meta.url).href,
    logoLeadPay186x84: new URL('./assets/images/logos/logo186x84_WithLeadPay.png', import.meta.url).href,
    welcome: new URL('./assets/images/welcome.png', import.meta.url).href,
    welcomeBackground: null,
    subscribeBanner: new URL('./assets/images/banners/subscribe.png', import.meta.url).href,
    pwaIosStep3: new URL('../../assets/images/system/install_pwa_ios_step3_bodybase.png', import.meta.url).href,
    pwaAndroidStep3: new URL('../../assets/images/system/install_pwa_android_step3_bodybase.png', import.meta.url).href,
  },
  subscription: {
    displayName: 'Bodybase',
    features: [
      {
        // TEMP: скрыт на /subscription/tariff-selection (premium-features)
        hidden: true,
        title: 'Закрытые эфиры с Мини Пеккой',
        text: 'Контент для тех, кто хочет расти в форме, силе и результате, а не собирать советы по кускам. Регулярные эфиры, разборы актуальных тем, ответы на вопросы и практические рекомендации, которые можно внедрять сразу.',
        image: new URL('../../views/subscriptions/images/features/bodybase/feature_1.png', import.meta.url).href,
      },
      {
        title: 'Персональная поддержка',
        text: 'Не остаёшься один на один со своими ошибками. Внутри подписки ты получаешь обратную связь, разбор техники, рекомендации по тренировочному процессу и поддержку, которая помогает двигаться увереннее и без хаоса.',
        image: new URL('../../views/subscriptions/images/features/bodybase/feature_2.png', import.meta.url).href,
      },
      {
        title: 'Эксклюзивные материалы и хаки',
        text: 'Собираем в одном месте личный опыт Мини Пекки: рабочие рекомендации, тренировочные материалы, практические фишки и инструменты, которые помогают быстрее выйти на заметный результат.',
        image: new URL('../../views/subscriptions/images/features/bodybase/feature_3.png', import.meta.url).href,
      },
    ],
    currentFeatures: [],
    includedFeatures: [
      {
        icon: new URL('../../assets/subscription/icon1.png', import.meta.url).href,
        title: 'HomePage.PremiumSubscriptions.LockedContent.Title',
        subtitle: 'HomePage.PremiumSubscriptions.LockedContent.Subtitle',
      },
      {
        icon: new URL('../../assets/subscription/icon3.png', import.meta.url).href,
        title: 'HomePage.PremiumSubscriptions.PersonalSupport.Title',
        subtitle: 'HomePage.PremiumSubscriptions.PersonalSupport.Subtitle',
      },
      {
        icon: new URL('../../assets/subscription/icon2.png', import.meta.url).href,
        title: 'HomePage.PremiumSubscriptions.Exclusive.Title',
        subtitle: 'HomePage.PremiumSubscriptions.Exclusive.Subtitle',
      },
    ],
  },
  desktopRoutes: [],
  broadcastRoutes: [
    {
      path: 'upcoming',
      name: 'BroadcastsUpcoming',
      component: () => import('./views/study/broadcasts/BroadcastsUpcoming.vue'),
    },
    {
      path: 'records',
      name: 'BroadcastsRecords',
      component: () => import('./views/study/broadcasts/BroadcastsRecords.vue'),
    },
  ],
  profileEditRoutes,
  myRoutes,
  hideNavBarRouteNames: [
    'TrainingsCatalog',
    'Bodybuilding',
    'BodybuildingChoiceProgram',
    'BodybuildingSpecialization',
    'BodybuildingProgramCreated',
    'BodybuildingScheduleStart',
    'Powerlifting',
    'PowerliftingOPM',
    'PowerliftingScheduleStart',
    'PowerliftingProgramCreated',
    'RandomTraining',
    'RandomTrainingFinalProgram',
  ],
  resolvePolicies(backendPolicies = {}) {
    return backendPolicies
  },
}

export { product }
